import React from "react"
import { Grid,
          List,
          ListItem,
          ListItemText,
          ListItemIcon
} from "@mui/material/"
import ToolsContent from "./content/tools"
import { APP_ICON } from "./assets/icons/IconList"

export default function ToolsPage() {
  return (
    <Grid
      container
      xs={12}
      sm={12}
      md={12}
      lg={12}
      spacing={3}
    >
  
      <Grid item xs={12} className="marginCenter">

          <Grid item xs={11} className="pageTitle" style={{margin: '20px auto'}} >
            
          <List style={{paddingLeft: '25px', marginTop: '10px'}} >
            <ListItem>
      
              <ListItemText
                primary={<div className="pageTitle" >Available Tools</div>}
              />
            </ListItem>
          </List>
         
       
          </Grid>

          <Grid item xs={11} style={{margin: '0 auto'}} >
          
            <ToolsContent />
    
          </Grid>

      </Grid>

    </Grid>
  )
}
